var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPreviewDownload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M7.336 8.05c-.002-.016-.002-.033-.002-.05V2.667C7.334 2.299 7.632 2 8 2c.369 0 .667.299.667.667V8l1.6-1.2c.295-.222.713-.161.933.133.222.295.162.713-.133.934l-2.667 2c-.118.088-.259.133-.4.133-.134 0-.268-.04-.383-.121L4.95 8.003c-.301-.212-.374-.628-.162-.929.212-.301.628-.374.929-.162l1.619 1.139zM4 11.334V12h8v-.667c0-.366.3-.666.667-.666.367 0 .667.3.667.666v1.334c0 .366-.3.666-.667.666H3.334c-.367 0-.667-.3-.667-.666v-1.334c0-.366.3-.666.667-.666.366 0 .666.3.666.666z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPreviewDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/preview_download.1ef55083.svg";
export { ForwardRef as ReactComponent };